import { motion } from "framer-motion";
import useWindowWidth from "../hooks/useWindowWidth";
import banner from "../assets/photo_2026-04-06_19-09-45.jpg";
export const Banner = ({ isOpen }) => {
  const width = useWindowWidth();
  const margin = width > 1359 ? "119px" : width > 639 ? "89px" : "65px";
  return (
    <section
      datatype="main"
      id="main-4"
      className="s-main-type-6 sb-block sb-block_fullscreen s-main-type-6_with-scroll-icon sb-text-white"
      style={isOpen ? { marginTop: margin } : undefined}
    >
      <div
        className="sb-background-image sb-background banner-bg"
        style={{ position: "absolute", inset: 0, overflow: "hidden" }}
      >
        <div
          className="banner-bg-blur"
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage: `url(${banner})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            filter: "blur(50px) brightness(0.45) saturate(1.15)",
            transform: "scale(1.2)",
          }}
        />
        <div
          style={{
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(135deg, rgba(15,20,30,0.55) 0%, rgba(15,20,30,0.3) 60%, rgba(15,20,30,0.55) 100%)",
          }}
        />
      </div>
      <div className="banner-photo-card">
        <motion.img
          src={banner}
          alt="Студия массажа Александра Стрельцова"
          initial={{ opacity: 0, scale: 0.94 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />
      </div>
      <style>{`
        .banner-photo-card {
          position: absolute;
          top: 50%;
          right: 6%;
          transform: translateY(-50%);
          width: 38%;
          max-width: 520px;
          aspect-ratio: 3 / 4;
          z-index: 2;
          border-radius: 18px;
          overflow: hidden;
          box-shadow: 0 30px 80px rgba(0,0,0,0.5), 0 10px 30px rgba(0,0,0,0.35);
          border: 1px solid rgba(255,255,255,0.08);
        }
        .banner-photo-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }
        @media (max-width: 1199px) {
          .banner-photo-card {
            width: 42%;
            right: 4%;
          }
        }
        @media (max-width: 991px) {
          .banner-photo-card {
            position: relative;
            top: auto;
            right: auto;
            transform: none;
            width: min(80%, 360px);
            margin: 24px auto 0;
            aspect-ratio: 3 / 4;
          }
        }
        @media (min-width: 2200px) {
          .s-main-type-6 {
            min-height: 900px !important;
            max-height: 1100px;
          }
          .banner-photo-card {
            max-width: 620px;
          }
        }
        .s-main-type-6 h1.sb-font-h1 {
          font-weight: 700;
          letter-spacing: -0.5px;
          text-shadow: 0 2px 24px rgba(0,0,0,0.5);
        }
        .s-main-type-6 .sb-font-p2 font {
          text-shadow: 0 1px 12px rgba(0,0,0,0.6);
          font-size: 1.05em;
          line-height: 1.6;
        }
      `}</style>
      <div className="s-main-type-6__wave-container">
        <div
          className=" sb-background sb-background sb-background_clear s-main-type-6__wave-editor"
          style={{ background: "#fff" }}
        ></div>
        <div className="s-main-type-6__wave">
          <svg
            className="s-main-type-6__wave-icon"
            width="2536"
            height="85"
            viewBox="0 0 2536 85"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0 5.24508C0 5.24508 383.286 56.6199 634 56.6199C884.714 56.6199 1017.29 1.01629 1268 0.031717C1518.12 -0.950562 1651.87 51.4065 1902 51.4065C2152.13 51.4065 2536 0.031717 2536 0.031717V87.0003H0V5.24508Z"
              fill="#fff"
            />
          </svg>
        </div>
      </div>
      <div className="sb-container sb-m-clear-top">
        <div className="sb-row ">
          <div className="sb-col_lg-8 sb-col_md-12 sb-col_sm-12 sb-col_xs-12 sb-m-clear-top">
            <div className="sb-m-clear-bottom">
              <motion.div
                initial={{ opacity: 0, transform: "translate3d(-200px, 0, 0)" }}
                animate={{ opacity: 1, transform: "translate3d(0, 0, 0)" }}
                transition={{ duration: 0.5 }}
              >
                <h1 className="sb-font-h1 sb-font-title sb-m-9-bottom">
                  Cтудия массажа
                  <div>Александра Стрельцова</div>
                </h1>
              </motion.div>
              <div className="sb-text-opacity sb-font-p2">
                <motion.div
                  initial={{
                    opacity: 0,
                    transform: "translate3d(-200px, 0, 0)",
                  }}
                  animate={{ opacity: 1, transform: "translate3d(0, 0, 0)" }}
                  transition={{ duration: 0.5, delay: 0.25 }}
                >
                  <font color="#ffffff">
                    Не откладывайте! Позвоните сейчас!<br />
                    Пора заняться своим здоровьем и красотой у профессионалов с медицинским образованием!
                  </font>
                </motion.div>
                <br />
              </div>
            </div>
            <motion.div
              className="s-main-type-6__buttons sb-m-6-top"
              initial={{
                opacity: 0,
                transform: "translate3d(-200px, 0, 0)",
              }}
              animate={{ opacity: 1, transform: "translate3d(0, 0, 0)" }}
              transition={{ duration: 0.5, delay: 0.5 }}
            >
              <a
                href="https://wa.me/79689333303"
                className="s-main-type-6__button sb-button-primary"
              >
                Оставить заявку
              </a>
              <a
                href="#product-list"
                className="s-main-type-6__button sb-button-secondary sb-button-type_bordered"
              >
                Узнать цены
              </a>
            </motion.div>
          </div>
        </div>
      </div>
      <a data-step-scroll="" className="step-scroll" href={"#about"}>
        <div className="step-scroll-round">
          <div className="step-scroll-arrow"></div>
        </div>
      </a>
    </section>
  );
};
